import { consent } from '../tracking-constants';

export const consentUpdated = () => ({
  event: 'consentUpdated',
  timestamp: Math.floor(Date.now() / 1000),
  user: {
    consent: consent(),
  },
});
